export const CURRENT_ORG_ROLES_QUERY = '/roles';
